export enum ReportModeEnum {
	OpenInTab = 1,
	Download = 2,
	OpenInModal = 3,
}
